import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import cn from 'classnames';
import BN from 'bignumber.js';
import styles from '../../styles/main/main.module.scss';
import stylesParent from '../../styles/frame/frame.module.scss';
import Tooltip from '../../../../../../components/tooltip';
import RosnIcon from '../../../../../../assets/images/rosn.svg';
import Header from '../../../../../../components/Stake/header';
import * as rosnStakeActions from '../../../../../../actions/rosn-stake-actions';
import { formatToken } from '../../../../../../helpers/token-helper';
import WithdrawCountdown from '../../../../../../components/withdraw-countdown';
import { toPowerOf } from '../../../../../../blockchain/config';
import { ROSN } from '../../../../../../constants/blockchain-constants';
import StakingStub from '../../../../../../components/staking-stub';
import RosnClosedLogo from '../../../../../../assets/images/rosn-closed-stub.svg';

const tooltipText = `
  Available ROSN for withdrawal includes both the ROSN that you are unstaking and the rewards you are claiming.
  Either of these two actions kick off an 8-day unlocking timer, after which the funds are available for withdrawal.
  Please note: if you are currently unstaking and decide to claim tokens half way through (or vice versa), the timer will
  be reset to 8-days, and you will be able to withdrawal both sets of tokens after 8-days.`;

const Main = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);

  const { unstakedBalance, unstakedTime } = useSelector((state) => state.ROSNstake.stake);

  const isDisabledWithdraw =
    unstakedTime > Date.now() / 1000 ||
    new BN(unstakedBalance).isLessThan(new BN(0.1).times(toPowerOf));

  return (
    <>
      <Header
        icon={RosnIcon}
        title={`${ROSN}-Staking`}
        // onClickHistory={() => dispatch(rosnStakeActions.showHistory())}
      />
      <div className={cn({ [styles.dark]: dark })}>
        <div className={cn(styles.stakeMoreWrapper, styles.pt0)}>
          <StakingStub
            type={ROSN}
            icon={RosnClosedLogo}
            text='The ROSN staking pool is now closed.'
          />
        </div>
        <div className={styles.unstakeContainer}>
          <Button
            className={styles.unstakeButton}
            onClick={() => dispatch(rosnStakeActions.unstakeSettings())}
            variant='contained'
          >
            Unstake
          </Button>
          <Tooltip
            className={styles.unstakeTooltip}
            label={`Available ${ROSN} for Withdrawal`}
            text={<div className={stylesParent.tooltipText}>{tooltipText}</div>}
          />
          <div className={styles.unstakeControls}>
            <div className={styles.unstakeControlsText}>
              <div className={cn(styles.unstakeControlValue, styles.active)}>
                <span>
                  {formatToken(unstakedBalance)} {ROSN}
                </span>
              </div>
              <div className={styles.unstakeControlDays}>
                <WithdrawCountdown
                  date={unstakedTime * 1000}
                  onDone={() => dispatch(rosnStakeActions.getUnstakes())}
                />
              </div>
            </div>
            <Button
              className={styles.secondaryButton}
              disabled={isDisabledWithdraw}
              onClick={() => dispatch(rosnStakeActions.withdrawUnstakedDetails())}
              variant='outlined'
            >
              Withdraw
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
